import {
  Alert,
  Grid,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Proposal } from "generated/graphql";
import useCustomGetProposal from "hooks/proposals/useCustomGetProposal";
import useProposalPackageSummary from "hooks/proposals/useProposalPackageSummary";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import ProposalActivityLog from "modules/proposals/ProposalActivityLog/ProposalActivityLog";
import ProposalInfo from "modules/proposals/ProposalInfo";
import ProposalPackageSendProgress from "modules/proposals/ProposalRecipients/ProposalPackageSendProgress";
import ParentProposalRecipientsTable from "modules/proposals/ProposalRecipients/ParentProposalRecipientsTable";
import ProposalRecipients from "modules/proposals/ProposalRecipients/ProposalRecipients";
import Versions from "modules/proposals/Versions/Versions";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

export default function ProposalInfoPage() {
  const { proposalId } = useParams();
  const { loading, data: proposal, error } = useCustomGetProposal({ id: proposalId });
  const { data: packageSummaryData } = useProposalPackageSummary(proposalId, !proposalId);
  const packageSummary = packageSummaryData?.getProposal as any;
  const isPackageParent = !!packageSummary?.isPackageParent;

  const latestProposalVersion =
    proposal && !proposal?.activeVersion && proposal.versions.find((p) => p.activeVersion)?.id;

  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          {proposal && !proposal?.activeVersion && (
            <Grid item xs={12}>
              <Alert variant="filled" severity="warning">
                You are on an older version of this proposal.{" "}
                <Link to={`/proposals/${latestProposalVersion}/info`}>Click here</Link> to go to
                latest version.{" "}
              </Alert>
            </Grid>
          )}

          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Proposal Info {proposal ? `#${proposal.versionWithPrefix}` : ""}
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        {!loading && !error && (
          <>
            {isPackageParent && packageSummary?.latestPackageSendRun && (
              <Grid item xs={12}>
                <ProposalPackageSendProgress packageSummary={packageSummary} />
              </Grid>
            )}
            <Grid item xs={12}>
              <ProposalInfo proposal={proposal as Proposal} />
            </Grid>
            <Grid item xs={12} mb={3}>
              <Versions proposal={proposal as Proposal} />
            </Grid>
            <Grid item xs={12}>
              {isPackageParent ? (
                <ParentProposalRecipientsTable packageSummary={packageSummary} />
              ) : (
                <ProposalRecipients proposal={proposal as Proposal} />
              )}
            </Grid>
            <Grid item xs={12}>
              <ProposalActivityLog proposal={proposal as Proposal} />
            </Grid>
          </>
        )}
      </Grid>
    </DashboardPage>
  );
}
